import { selectSGIPIncentiveValue } from '../sgip/selectors';
import { getNYRebateTotal } from '../nyserda/selectors';

export const getITC = (state, year) => {
    const { installYear } = state.tax;
    const { cashprice } = state.solar;
    const {
        loanProvider, showLoan, mosaicFee, mosaicDownPayment, downPayment,
    } = state.loan;
    const { projectState } = state.projectaddress;

    const zero = 0;
    if (year > 1) {
        return zero;
    }

    let netRebate = cashprice;
    if (projectState === 4) {
        netRebate = cashprice - getNYRebateTotal(state);
    }

    let deposit = downPayment;
    if (loanProvider === 'mosaic') {
        deposit = mosaicDownPayment;
    }
    const mosaicAmount = (cashprice - deposit) * mosaicFee;

    let finalPrice = netRebate;
    if (loanProvider === 'mosaic' && showLoan && projectState === 4) {
        finalPrice = mosaicAmount + deposit - getNYRebateTotal(state);
    }
    if (loanProvider === 'mosaic' && showLoan) {
        finalPrice = mosaicAmount + deposit;
    }


    let itcPercentage = 0.26;
    if (installYear === 2020) {
        itcPercentage = 0.26;
    } else if (installYear === 2021) {
        itcPercentage = 0.22;
    } else if (installYear > 2021) {
        itcPercentage = 0.1;
    }

    return itcPercentage * finalPrice;
};
export const getITCCashESS = (state, year) => {
    const { installYear } = state.tax;
    const { essPrice } = state.ess;

    const zero = 0;
    if (year > 1) {
        return zero;
    }

    let itcPercentage = 0.26;
    if (installYear === 2020) {
        itcPercentage = 0.26;
    } else if (installYear === 2021) {
        itcPercentage = 0.22;
    } else if (installYear > 2021) {
        itcPercentage = 0.1;
    }

    return itcPercentage * essPrice;
};
export const getCashITC = (state, year) => {
    const { installYear } = state.tax;
    const { cashprice } = state.solar;
    const { projectState } = state.projectaddress;

    const zero = 0;
    if (year > 1) {
        return zero;
    }

    let netRebate = cashprice;
    if (projectState === 4) {
        netRebate = cashprice - getNYRebateTotal(state);
    }


    const finalPrice = netRebate;


    let itcPercentage = 0.3;
    if (installYear === 2020) {
        itcPercentage = 0.26;
    } else if (installYear === 2021) {
        itcPercentage = 0.22;
    } else if (installYear > 2021) {
        itcPercentage = 0.1;
    }

    return itcPercentage * finalPrice;
};

export const getMACRS = (state) => {
    const { installYear, taxRate, resiToggle } = state.tax;
    const { cashprice } = state.solar;
    const { projectState } = state.projectaddress;

    if (resiToggle === true) {
        const macrsValue = 0;
        return macrsValue;
    }

    let netRebate = cashprice;
    if (projectState === 4) {
        netRebate = cashprice - getNYRebateTotal(state);
    }

    let itcPercentage = 0.26;
    if (installYear === 2020) {
        itcPercentage = 0.26;
    } else if (installYear === 2021) {
        itcPercentage = 0.22;
    } else if (installYear > 2021) {
        itcPercentage = 0.1;
    }

    const macrsBasis = 1 - (itcPercentage / 2);

    const macrsValue = netRebate * macrsBasis * (taxRate / 100);
    return macrsValue;
};

export const getMACRSESS = (state) => {
    const { installYear, taxRate, resiToggle } = state.tax;
    const { essPrice } = state.ess;

    if (resiToggle === true) {
        const macrsValue = 0;
        return macrsValue;
    }

    let itcPercentage = 0.26;
    if (installYear === 2020) {
        itcPercentage = 0.26;
    } else if (installYear === 2021) {
        itcPercentage = 0.22;
    } else if (installYear > 2021) {
        itcPercentage = 0.1;
    }

    const macrsBasis = 1 - (itcPercentage / 2);

    const macrsValue = essPrice * macrsBasis * (taxRate / 100);
    return macrsValue;
};

export const getOBSITC = (state, year) => {
    const { cashprice } = state.solar;
    const { sgipToggle } = state.sgip;
    const { essPrice, includeESS } = state.ess;
    const { projectState } = state.projectaddress;
    const { obsDownPayment } = state.obs;
    const { obsTerm } = state.obs;
    const { resiToggle } = state.tax;


    if (resiToggle === true) {
        const macrsValue = 0;
        return macrsValue;
    }

    let obsPrice = cashprice - obsDownPayment;
    if (includeESS === true && sgipToggle === true && projectState === 1) {
        obsPrice = cashprice + essPrice - selectSGIPIncentiveValue(state) - obsDownPayment;
    } else if (includeESS === true && projectState !== 1) {
        obsPrice = cashprice + essPrice - obsDownPayment;
    }

    let obsBuyout = 0;
    if (obsPrice < 100000 && year === 6 && obsTerm === 60) {
        obsBuyout = obsPrice * 0.20;
    }
    if (cashprice < 250000 && year === 8) {
        obsBuyout = obsPrice * 0.20;
    }
    if (year === 8 && cashprice >= 250000) {
        obsBuyout = obsPrice * 0.15;
    }

    return 0.1 * obsBuyout;
};



// WEBPACK FOOTER //
// ./src/containers/common/tax/selectors.js